import { Button, LuIcon } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const IssueTypeSettingsDetailViewTopBar = memo(() => {
	return (
		<BaseTopBar
			showAIButton={false}
			leftContent={
				<Link
					from="/$organizationId/settings/issue-types/$issueTypeId"
					to="/$organizationId/settings/issue-types"
				>
					<Button variant="ghost" accentColor="base">
						<LuIcon icon={modelIconMapping.arrowLeft} />
						Issue types
					</Button>
				</Link>
			}
		/>
	)
})
IssueTypeSettingsDetailViewTopBar.displayName = "IssueTypeSettingsDetailViewTopBar"
